'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.inView = twentyninetimes.inView || function () {

	function init(items, itemFunction, inAdvance) {
		if ( !items ) return;
		if ( !inAdvance ) var inAdvance = 100;

		// Check if browser supports IntersectionObserver
		if ("IntersectionObserver" in window) {

			let itemObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						let item = entry.target;

						itemFunction(item);

						itemObserver.unobserve(item);
					}
				});
			}, {
				// Load image when 100px above bo
				rootMargin: `0px 0px ${inAdvance}px 0px`
			});

			items.forEach(function(item) {
				itemObserver.observe(item);
			});

		// Fallback if browser doesn't support IntersectionObserver
		} else {

			let active    = false;

			const itemsInView = function() {
				if (active === false) {
					active = true;

					setTimeout(function() {
						items.forEach(function(item) {
							let element_img = item.getElementsByTagName('img')[0];

							if ((item.getBoundingClientRect().top <= window.innerHeight - inAdvance && item.getBoundingClientRect().bottom >= 0) && getComputedStyle(item).display !== "none") {

								itemFunction(item);

								items = items.filter(function(map) {
									return map !== item;
								});

								if (items.length === 0) {
									document.removeEventListener('scroll', itemsInView);
									window.removeEventListener('resize', itemsInView);
									window.removeEventListener('orientationchange', itemsInView);
								}
							}
						});

						active = false;
					}, 200);
				}
			};

			itemsInView();
			document.addEventListener('scroll', itemsInView);
			window.addEventListener('resize', itemsInView);
			window.addEventListener('orientationchange', itemsInView);

		}
	}

	return {
		init : init
	};

}();